'use strict';
const angular = require('angular');

/*@ngInject*/
export function CalendarEventService($resource) {
  return $resource('/api/calendar-events/:id', {
    id: '@_id'
  },{
    getByType: {
      method: 'GET',
      url: "/api/calendar-events/type/:type",
      isArray: true
    },
    patch: {
      method: 'PATCH'
    },
    update: {
      method: 'PUT'
    },
    getIcalFile: {
      method: 'GET',
      url: "/api/calendar-events/:id/ical"
    },
    getUpcoming: {
      method: 'GET',
      url: "/api/calendar-events/upcoming/:count",
      isArray: true
    }
  });
}


export default angular.module('conduuApp.CalendarEventService', [])
  .factory('CalendarEventService', CalendarEventService)
  .name;



// WEBPACK FOOTER //
// ./client/services/calendar/event.service.js